/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMarkAllAsRead = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m16.907 4.707-1.414-1.414L7.2 11.586 3.707 8.093 2.293 9.507 7.2 14.414zM16 11h6V9h-6zm-4 5h10v-2H12zM2 21v-2h20v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMarkAllAsRead as MarkAllAsRead };
